document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-toggle]').forEach(item => {
        new CustomAccordion(item.id);
    })
  })

class CustomAccordion {
    constructor(containerId) {
      this.container = document.getElementById(containerId);
      if(!this.container) return;
      this.items = this.container.querySelectorAll('.toggle-item');
      this.init();
    }
  
    init() {
      this.items.forEach(item => {
        const header = item.querySelector('.toggle-header');
        header.addEventListener('click', () => this.toggleItem(item));
      });
    }
  
    toggleItem(item) {
      const isOpen = item.classList.contains('active');
      
      // 关闭所有项目
      this.items.forEach(i => i.classList.remove('active'));
      
      // 切换当前项目
      if (!isOpen) {
        item.classList.add('active');
      }
    }
  }

// swpier
 (function () {

  function initEllaSimpleSliders() {

      const sliders = document.querySelectorAll('.ella-simple-slider');

      sliders.forEach(function (slider) {

          /*
            * 防止 Shopify 页面编辑器或重复 script
            * 导致同一个轮播被初始化多次
            */
          if (slider.dataset.sliderInitialized === 'true') {
              return;
          }

          slider.dataset.sliderInitialized = 'true';


          const track = slider.querySelector('.ella-simple-slider__track');
          const slides = slider.querySelectorAll('.ella-simple-slider__slide');

          const prev = slider.querySelector(
              '.ella-simple-slider__arrow--prev'
          );

          const next = slider.querySelector(
              '.ella-simple-slider__arrow--next'
          );

          const dotsBox = slider.querySelector(
              '.ella-simple-slider__dots'
          );


          if (!track || !slides.length) {
              return;
          }


          let index = 0;
          let timer = null;


          /* =========================
              Create dots
          ========================= */

          if (dotsBox) {

              dotsBox.innerHTML = '';

              slides.forEach(function (slide, i) {

                  const dot = document.createElement('button');

                  dot.type = 'button';

                  dot.className = 'ella-simple-slider__dot';

                  dot.setAttribute(
                      'aria-label',
                      'Go to slide ' + (i + 1)
                  );


                  if (i === 0) {
                      dot.classList.add('active');
                  }


                  dot.addEventListener('click', function () {

                      index = i;

                      updateSlider();

                      resetAutoplay();

                  });


                  dotsBox.appendChild(dot);

              });

          }


          /* =========================
              Update
          ========================= */

          function updateSlider() {

              track.style.transform =
                  'translateX(-' + (index * 100) + '%)';


              if (dotsBox) {

                  const dots = dotsBox.querySelectorAll(
                      '.ella-simple-slider__dot'
                  );

                  dots.forEach(function (dot, i) {

                      dot.classList.toggle(
                          'active',
                          i === index
                      );

                  });

              }

          }


          /* =========================
              Next
          ========================= */

          function goNext() {

              index++;

              if (index >= slides.length) {
                  index = 0;
              }

              updateSlider();

          }


          /* =========================
              Previous
          ========================= */

          function goPrev() {

              index--;

              if (index < 0) {
                  index = slides.length - 1;
              }

              updateSlider();

          }


          if (next) {

              next.addEventListener('click', function () {

                  goNext();

                  resetAutoplay();

              });

          }


          if (prev) {

              prev.addEventListener('click', function () {

                  goPrev();

                  resetAutoplay();

              });

          }


          /* =========================
              Autoplay
          ========================= */

          function startAutoplay() {

              if (slides.length <= 1) {
                  return;
              }


              timer = setInterval(function () {

                  goNext();

              }, 5000);

          }


          function stopAutoplay() {

              if (timer) {

                  clearInterval(timer);

                  timer = null;

              }

          }


          function resetAutoplay() {

              stopAutoplay();

              startAutoplay();

          }


          /*
            * 鼠标移入停止自动播放
            */
          slider.addEventListener('mouseenter', stopAutoplay);


          slider.addEventListener('mouseleave', startAutoplay);


          /* =========================
              Touch swipe
          ========================= */

          let touchStartX = 0;

          let touchEndX = 0;


          slider.addEventListener(
              'touchstart',
              function (event) {

                  touchStartX =
                      event.changedTouches[0].screenX;

              },
              { passive: true }
          );


          slider.addEventListener(
              'touchend',
              function (event) {

                  touchEndX =
                      event.changedTouches[0].screenX;


                  const distance =
                      touchStartX - touchEndX;


                  if (Math.abs(distance) < 50) {
                      return;
                  }


                  if (distance > 0) {

                      goNext();

                  } else {

                      goPrev();

                  }


                  resetAutoplay();

              },
              { passive: true }
          );


          /* =========================
              One slide
          ========================= */

          if (slides.length <= 1) {

              if (prev) {
                  prev.style.display = 'none';
              }

              if (next) {
                  next.style.display = 'none';
              }

              if (dotsBox) {
                  dotsBox.style.display = 'none';
              }

          }


          startAutoplay();

      });

  }


  if (document.readyState === 'loading') {

      document.addEventListener(
          'DOMContentLoaded',
          initEllaSimpleSliders
      );

  } else {

      initEllaSimpleSliders();

  }


  /*
    * Shopify Theme Editor
    */
  document.addEventListener(
      'shopify:section:load',
      initEllaSimpleSliders
  );

})();